import { Button } from '@/components/ui/button';
import { PackagePlus } from 'lucide-react';
import { useNotify, useRecordContext } from 'ra-core';
import { useNavigate } from 'react-router-dom';
import { useHasPermission } from '../../rbac/useHasPermission';
import { PurchaseOrder } from '../../types';

export const ReceiveGoodsButton = () => {
    const record = useRecordContext<PurchaseOrder>();
    const navigate = useNavigate();
    const notify = useNotify();
    const { hasPermission: canManage } = useHasPermission('manage_procurement');

    if (!record || record.status !== 'approved' || !canManage) return null;

    const handleReceiveGoods = () => {
        if (!record.items || record.items.length === 0) {
            notify('Cannot receive goods: PO has no items.', { type: 'warning' });
            return;
        }

        navigate('/goods_receipts/create', {
            state: {
                record: {
                    po_id: record.id,
                    vendor_id: record.vendor_id,
                    status: 'draft',
                }
            }
        });
    };

    return (
        <Button 
            onClick={handleReceiveGoods} 
            className="bg-emerald-600 hover:bg-emerald-700 text-white"
        >
            <PackagePlus className="w-4 h-4 mr-2" />
            Receive Goods
        </Button>
    );
};
